/**
 * **서버 진행을 지켜보는 화면의 폴링 간격 한 곳** — 의존성 없는 순수 모듈이다(Vue·`@/` 별칭 금지 — 단위 시험이 node 에서
 * 그대로 읽는다). 배달 메뉴·옵션 품절의 진행 드로어(`posDeliverySoldout` — 옛 이름으로 다시 내보낸다)와 고객 가져오기
 * (`customerImport.importPollNext`)가 같은 간격을 쓴다.
 *
 * 간격은 두 단계다 — 서버가 놀고 있으면 몇 초 안에 끝나므로 처음 30초는 촘촘히 보고, 그 뒤로는 느슨하게 본다. **조회가 곧
 * 서버의 일**(품절은 지연 재계획, 가져오기는 진행 읽기)이라 간격을 더 줄이지 않는다.
 *
 * **상한([POLL_WATCH_CAP_MS])은 「일이 끝나는 시간」이 아니라 「사람이 서서 보는 시간」이다.** 품절 반영은 실측(2026-09-03
 * dev) 7분이 걸렸고 큰 파일의 포인트 쓰기는 분 단위다 — 어떤 상한을 골라도 넘기는 것이 정상 경로다. 그래서 상한의 역할은
 * 「끝까지 본다」가 아니라 **「그만 보는 자리를 정직하게 만드는 것」**이다: 멈춘 뒤에는 마지막 확인 시각을 말하고 「다시
 * 확인」으로 재개할 수 있어야 한다. 상한에서 멈출지 이어 갈지는 화면마다 다르다(가져오기는 서버가 「멈추지 않았다」고 말하는
 * 동안 이어 간다) — 그 규칙은 각 화면의 판정이 갖고, 숫자는 여기 하나다.
 */

/** 처음 [POLL_FAST_WINDOW_MS] 동안의 간격 */
export const POLL_FAST_MS = 3000

/** 그 뒤의 간격 */
export const POLL_SLOW_MS = 10000

/** 촘촘히 보는 창 — 시작(또는 다시 확인)부터 */
export const POLL_FAST_WINDOW_MS = 30000

/** 사람이 서서 보는 상한 — 넘으면 화면이 멈춤을 말한다(이어 갈지는 화면의 판정) */
export const POLL_WATCH_CAP_MS = 300000

/**
 * 이번 회차의 폴링 간격 — 시작 뒤 [POLL_FAST_WINDOW_MS] 안이면 촘촘히, 그 뒤로는 느슨하게. 순수(시계는 인자).
 *
 * @param {number} elapsedMs 시작(또는 다시 확인)부터 지난 시간
 * @returns {number} 다음 조회까지의 대기(ms)
 */
export function pollDelayOf(elapsedMs) {
  return elapsedMs < POLL_FAST_WINDOW_MS ? POLL_FAST_MS : POLL_SLOW_MS
}
